import { filesToDocuments } from '@equifinance/shared';
import { TaskDocument } from '../../../contexts/tasks';

export const filesToTaskDocuments = async (files: File[], taskId: string): Promise<TaskDocument[]> => {
  const documents = await filesToDocuments(files);

  return documents.map(({ name, data, extension }) => ({
    taskId,
    fileName: name,
    documentData: data,
    documentType: extension,
  }));
};
